import React, { Button, Component, useState } from "react";
// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from "universal-cookie";
import LoadingOverlay from "react-loading-overlay";
import Table from "../../widgets/tables/Table";
import WaitDialog from "../../widgets/WaitDialog";
import getEventi from "../../services/getEventi";
import deleteEvento from "../../services/deleteEvento";

const endLine = "\n";

export default class Sconti extends React.Component {
	constructor(props) {
		super(props);

		this.pageDiv = {
			border: "1px solid #cccccc",
			padding: 10,
		};

		this.state = {};

		this.eventi = [];
		this.pageTitle = "Sconti";
	}

	async reload() {
		const cookies = new Cookies();
		const username = cookies.get("username", { path: "/" });
		const token = cookies.get("token", { path: "/" });

		//this.eventi = await getEventi(username, token, "admin");
		this.setState({});
	}

	async componentDidMount() {
		await this.reload();
	}

	render() {
		const cookies = new Cookies();

		var headCells = [
			{ id: "descrizione", numeric: false, disablePadding: true, label: "Descrizione" },
			{ id: "corso", numeric: false, disablePadding: true, label: "Corso" },
			{ id: "_", numeric: true, disablePadding: false, label: "" },
		];

		this.searchCols = ["titolo"];

		return (
			<div id={Math.random()}>
				<LoadingOverlay
					active={this.state.isLoading}
					styles={{
						content: base => ({
							position: "relative",
							width: "100%",
							top: "200px",
						}),
					}}
					spinner
					text={"Loading your content..."}
				>
					<PageTitle
						title="Sconti"
						button="NUOVO"
						onClick={() => {
							window.location.href = "/#/app/addSconto";
						}}
					/>

					<Table
						headCells={headCells}
						searchCols={this.searchCols}
						rows={this.eventi}
						// onEventClick={row => {
						// 	cookies.set("currentEvent", row, { path: "/" });
						// 	window.location.href = "/#/app/editEvento";
						// }}
						// onDelete={async id => {
						// 	if (window.confirm("Sei sicuro di voler eliminare questo evento?") == false) return;

						// 	const cookies = new Cookies();
						// 	const username = cookies.get("username", { path: "/" });
						// 	const token = cookies.get("token", { path: "/" });
						// 	await deleteEvento(username, token, id);
						// 	this.reload();
						// }}
					/>

					{this.elementPdf ? this.elementPdf : null}
					<WaitDialog show={this.state.waitDialogVisible} key={Math.random()} index={this.state.index} />
				</LoadingOverlay>
			</div>
		);
	}
}
